import type { InputHTMLAttributes, ReactNode } from "react";

type SwitchProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  label: ReactNode;
  description?: ReactNode;
  density?: "row" | "inline";
};

export function Switch({
  label,
  description,
  density = "row",
  className = "",
  ...props
}: SwitchProps) {
  return (
    <label
      className={`flex items-start justify-between gap-4 text-sm text-text transition ${
        density === "row"
          ? "card-paper p-4 hover:border-accent-200 hover:bg-surface"
          : "rounded-[var(--radius-input)] border border-transparent py-2"
      } ${className}`}
    >
      <span>
        <span className="block font-semibold text-text">{label}</span>
        {description ? (
          <span className="mt-1 block leading-6 text-text-muted">{description}</span>
        ) : null}
      </span>
      <span className="relative mt-0.5 inline-flex h-7 w-12 shrink-0 items-center">
        <input
          className="peer h-7 w-12 appearance-none rounded-pill border border-border bg-surface-sunken transition checked:border-accent-600 checked:bg-accent-600 focus-visible:outline-none focus-visible:shadow-[var(--shadow-ring-focus)]"
          type="checkbox"
          {...props}
        />
        <span className="pointer-events-none absolute left-0.5 h-5 w-5 rounded-pill bg-surface-raised shadow-sm transition-transform duration-[var(--duration-spring)] ease-[var(--ease-spring)] peer-checked:translate-x-[1.375rem]" />
      </span>
    </label>
  );
}
